import * as yup from "yup";

const validationModel = yup.object().shape({
  id: yup.number().required(),
  bookingId: yup.string().required("Booking id is required"),
  pnr: yup.string().when("bookingStatus", {
    is: "COMPLETED",
    then: yup.string().nullable().required("PNR is required"),
    otherwise: yup.string().nullable().default(null).optional(),
  }),
  bookingStatus: yup.string().required("Booking Status is required"),
  totalBF: yup.string().required("Total Base Fare is required"),
  totalTF: yup.string().required("Total Fare is required"),
  totalTAF: yup.string().required("Total Tax Fare is required"),
  totalNF: yup.string().required("Total Net Fare is required"),

  isDomestic: yup.boolean().optional(),
  travellerInfo: yup.array().of(
    yup.object().shape({
      passengerId: yup.number().required("Passenger Id is required"),
      ti: yup.string().required("Title is required"),
      fN: yup.string().required("first name is required"),
      lN: yup.string().required("last name is required"),
      pt: yup.string().required("Passenger type is required"),
      gdsPnrs: yup.string().nullable().default(null),
      // .required("Ticket Number is required")
      dob: yup.string().optional(),
      // .when("isDomestic", {
      //   is: false,
      //   then: yup.string().required("Date of birth is required"),
      // }),
      pNum: yup.string().when("isDomestic", {
        is: false,
        then: yup.string().required("Passport number date is required"),
        otherwise: yup.string().nullable().default(null),
      }),
      eD: yup.string().when("isDomestic", {
        is: false,
        then: yup.string().required("Passport expiry date is required"),
        otherwise: yup.string().nullable().default(null),
      }),
      pid: yup.string().when("isDomestic", {
        is: false,
        then: yup.string().required("Passport issue date is required"),
        otherwise: yup.string().nullable().default(null),
      }),
      pNat: yup.string().when("isDomestic", {
        is: false,
        then: yup.string().required("Passport nationality date is required"),
        otherwise: yup.string().nullable().default(null),
      }),
    })
  ),
});

export { validationModel };
